import { useEffect, useState } from 'react';
import api from '../services/ApiService';
import { ZoomTable, ZoomBtn, ZoomBadge, ZoomModal, ZoomField } from './zoom/ZoomTable';

// External Contacts (company CRM) — Zoom-style front-end over /api/crm/customers.
// Shared across the tenant's agents + support staff; powers inbound caller-ID.
export default function ExternalContactsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [edit, setEdit] = useState<any | null>(null);
  const [form, setForm] = useState<any>({ first_name: '', last_name: '', company: '', email: '', phone: '', notes: '' });

  const load = async () => { try { setRows((await api.getCrmCustomers({ limit: 500 })) || []); } catch { /* ignore */ } };
  useEffect(() => { load(); }, []);

  const openAdd = () => { setEdit(null); setForm({ first_name: '', last_name: '', company: '', email: '', phone: '', notes: '' }); setShowForm(true); };
  const openEdit = (c: any) => {
    setEdit(c);
    setForm({ first_name: c.first_name || '', last_name: c.last_name || '', company: c.company_name || c.company || '', email: c.email || '', phone: c.phone || '', notes: c.notes || '' });
    setShowForm(true);
  };
  const save = async () => {
    if (!form.phone.trim()) { alert('Phone number is required'); return; }
    const payload = { first_name: form.first_name, last_name: form.last_name, company_name: form.company, email: form.email, phone: form.phone, notes: form.notes };
    if (edit) await api.updateCrmCustomer(edit.id, payload); else await api.createCrmCustomer(payload);
    setShowForm(false); await load();
  };
  const del = async (c: any) => { if (!window.confirm(`Delete ${c.name || c.phone}?`)) return; await api.deleteCrmCustomer(c.id); await load(); };

  const filtered = rows.filter((c) =>
    !search.trim() || `${c.name || ''} ${c.company_name || c.company || ''} ${c.email || ''} ${c.phone || ''}`.toLowerCase().includes(search.toLowerCase()));

  const columns: any[] = [
    { key: 'name', label: 'Display Name', render: (c: any) => <div className="z-tbl-primary-cell">{c.name || '—'}</div> },
    { key: 'company', label: 'Company', render: (c: any) => c.company_name || c.company || '—' },
    { key: 'email', label: 'Email', render: (c: any) => c.email || '—' },
    { key: 'phone', label: 'Phone Number', render: (c: any) => (<div>{c.phone}{c.phone2 && <div className="z-tbl-sub">{c.phone2}</div>}</div>) },
    { key: 'status', label: 'Status', render: (c: any) => <ZoomBadge text={c.status || 'active'} tone={c.status === 'inactive' ? 'gray' : 'green'} /> },
  ];

  return (
    <>
      {showForm && (
        <ZoomModal
          title={edit ? 'Edit External Contact' : 'Add External Contact'}
          onClose={() => setShowForm(false)}
          footer={<><ZoomBtn onClick={() => setShowForm(false)}>Cancel</ZoomBtn><ZoomBtn variant="primary" onClick={save}>Save</ZoomBtn></>}
        >
          <div className="z-field-grid">
            <ZoomField label="First Name"><input value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} /></ZoomField>
            <ZoomField label="Last Name"><input value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} /></ZoomField>
          </div>
          <ZoomField label="Company"><input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} /></ZoomField>
          <div className="z-field-grid">
            <ZoomField label="Phone Number" hint="Required"><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+9715..." /></ZoomField>
            <ZoomField label="Email"><input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></ZoomField>
          </div>
          <ZoomField label="Notes"><input value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} /></ZoomField>
        </ZoomModal>
      )}

      <ZoomTable
        title="External Contacts"
        subtitle="Your company's shared contact database (CRM)."
        banner={<span>Shared with your agents and support staff — these contacts power inbound caller-ID matching.</span>}
        search={search}
        onSearch={setSearch}
        searchPlaceholder="Search contacts"
        actions={<><ZoomBtn onClick={() => alert('Bulk import — coming soon')}>Import</ZoomBtn><ZoomBtn variant="primary" onClick={openAdd}>+ Add external contact</ZoomBtn></>}
        columns={columns}
        rows={filtered}
        rowKey={(c: any) => c.id}
        rowActions={(c: any) => (<><ZoomBtn onClick={() => openEdit(c)}>Edit</ZoomBtn><ZoomBtn variant="danger" onClick={() => del(c)}>Delete</ZoomBtn></>)}
        emptyText="No external contacts yet"
      />
    </>
  );
}
